<template>
  <a
    :class="{ hidden: isOnTop }"
    class="back-to-top"
    title="Back to top"
    @click.prevent="scrollTop()"
  >
    <i class="ion ion-chevron-up back-to-top-icon" />
  </a>
</template>

<script>
const THRESHOLD = 0

export default {
  data() {
    return {
      isOnTop: true,
    }
  },
  created() {
    window.smoothscroll = () => {
      const currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll)
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5))
      }
    }

    this.updateIsOnTop()
    window.addEventListener('scroll', this.updateIsOnTop)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateIsOnTop)
  },
  methods: {
    updateIsOnTop() {
      this.isOnTop = window.scrollY <= THRESHOLD
    },
    scrollTop() {
      window.smoothscroll()
    },
  },
}
</script>

<style lang="scss">
.back-to-top {
  cursor: pointer;
}
</style>
